import React, { Component, PropTypes } from 'react';
import { FileUploader } from '@beisen/chaos-ui';
import * as helper from '../../util/helper';
import transLoader from '@beisen/i18n-translation-loader';
require('./fileupload.css');

const defaultTranslation = {
	'uploadFaildTip': '上传失败!',
	'required': '必填',
	'attention': '注意',
	'cancel': '取消',
	'confirm': '确定',
	'deletMsg': '你确定要删除这些信息吗，删除后不可恢复。',
  'fileOverTip': '附件数量超过$count个！',
  'fileSizeBigError': '上传文件大小不得超过{0}！'
};
class FileUpload extends React.Component {
	constructor(props) {
		super(props);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleSuccess = this.handleSuccess.bind(this);
		this.handleError = this.handleError.bind(this);
		this.handleBeforeUpload = this.handleBeforeUpload.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getDeleteParam = this.getDeleteParam.bind(this);
    this.tipErrorMessage = this.tipErrorMessage.bind(this);
		this.state = {
			fileList: [],
			upSuccer: false
        };
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            uploadFaildTip: 'fileUpload.uploadFaildTip',
            required: 'common.required',
            attention: 'common.attention',
            cancel: 'common.cancel',
            confirm: 'common.confirm',
            deletMsg: 'modal.deletMsg',
            fileOverTip: 'fileUpload.fileOverTip',
            fileSizeBigError: 'fileUpload.fileSizeBigError'
        }), props.translation);

        this.defaultValidator = {
          FileSize: '5',
          FileUnit: 'MB',
          Message: this.translation.fileSizeBigError.replace('{0}','5MB')
        };
	}

	componentWillMount() {
		this.convertToList();
	}

	convertToList() {
		let hasLoad = [];
		if (this.props.clientUrl) {
			let clientUrllenth = this.props.clientUrl.split(',');
			for (let i = 0; i < clientUrllenth.length; i++) {
				hasLoad.push({
					Name: this.props.text.split(',')[i],
					Path: this.props.value.split(',')[i],
					ClientUrl: helper.picUrlRenaming(this.props.clientUrl.split(',')[i]),
					DownLoadUrl: this.props.downloadUrl.split(',')[i],
					uid: this.props.clientUrl.split(',')[i]
				});
			}
		}
		this.setState({ fileList: hasLoad });
    }

	allowDelete() {
		return this.props.cmp_data.cmp_status != 'readonly';
	}

	allowUpload() {
		return this.props.cmp_data.cmp_status != 'readonly';
	}

	handleBeforeUpload(file) {
		if(this.props && this.props.validators) {
			let { FileExtensionValidate,FileSizeValidate } = this.props.validators;
			if(FileExtensionValidate && FileExtensionValidate.FileExtension) {
				let ext = file.name.slice(file.name.lastIndexOf('.') + 1);
				if(!FileExtensionValidate.FileExtension.includes(ext.toLocaleLowerCase())) {
					this.props.actions.showTip({ message: FileExtensionValidate.Message, type: 'error' });
					return false;
				}
			}
			if(FileSizeValidate && FileSizeValidate.FileSize && FileSizeValidate.FileUnit) {
				if(file.size > helper.convertSize(FileSizeValidate.FileSize,FileSizeValidate.FileUnit)) {
					this.props.actions.showTip({ message: FileSizeValidate.Message, type: 'error' });
					return false;
				}
      }

      if(file.size > helper.convertSize(this.defaultValidator.FileSize,this.defaultValidator.FileUnit)) {
        this.props.actions.showTip({ message: this.defaultValidator.Message, type: 'error' });
        return false;
      }

		}
		return true;
	}


	handleDelete(deleteSuccess, i) {
		let newList = this.state.fileList.slice();
		newList.splice(i, 1);
		let pathArr = [],
			textArr = [],
			clientUrlArr = [],
			downLoadUrlArr = [];
		newList.forEach(file => {
			if (file.Path) {
				pathArr.push(file.Path);
				textArr.push(file.Name);
				clientUrlArr.push(file.ClientUrl);
				downLoadUrlArr.push(file.DownLoadUrl);
			}
		});
		this.setState({ fileList: newList });

		if (deleteSuccess) {
			if (this.props.onChange) {
				const newVal = {
					text: textArr.join(','),
					value: pathArr.join(','),
					fileName: textArr.join(','),
					clientUrl: clientUrlArr.join(','),
					downloadUrl: downLoadUrlArr.join(',')
				};
				this.props.actions.deleteFile(
					this.props.form_id,
					this.props.cmp_id,
					this.props.cmp_data.field_name_for_multi ? this.props.cmp_data.field_name_for_multi : this.props.cmp_data.field_name,
					newVal
				);
				this.setState({ upSuccer: false });
			}
		}
	}

	handleSuccess(res, file) {
		this.setState({ upSuccer: true });
		this.props.actions.uploadFileSuccess(
			res,
			this.props.form_id,
			this.props.cmp_id,
			this.props.cmp_data.field_name_for_multi ? this.props.cmp_data.field_name_for_multi : this.props.cmp_data.field_name,
			this.props.cmp_data.multiple
		);
	}

	handleError(err, ret, file) {
		const { translation } = this;
		this.props.actions.showTip({ message: translation.uploadFaildTip, type: 'error' });
	}

	getDeleteParam(file) {
		return {
			path: this.props.value
		};
	}

	handleChange(currentFile) {
		this.setState({ fileList: currentFile });
	}

	tipErrorMessage(message) {
		this.props.actions.showTip({ message: message, type: 'error' });
	}
	//如果是安卓微信&&上传类型包含图片则改变accept传的值，是为了解决安卓微信6.5.3以上版本设置了accpet具体的image选择不了图片的bug
	//当为图片时统一改为image/*
	getAcceptProps() {
		const cmp_accept = this.props.cmp_data.accept || '';
		return (helper.isAndroidWeixin() && cmp_accept.indexOf('image') > -1) ? 'image/*' : cmp_accept;
	}
	render() {
        const { uploadUrl, desc, errorMessage, styleTitle, ...other } = this.props;
        const { translation } = this;
		const downloadUrl =
			this.props.cmp_data.downloadUrl || this.props.downloadUrl; //待删
		const locationObj = window.location;

		const appName =  this.props.cmp_data.applicationName || BSGlobal.application;
		const metaObjName = this.props.cmp_data.metaObjectName || this.props.form_context.metaObjName;

		const uploadURL =
			locationObj.origin +
			helper.addShadowContextUrl('/api/v2/Data/File?app=' + appName + '&metaObjName=' + metaObjName, true);

		const required = this.props.isReadOnly ? null : this.props.required;

        let errMsg;
		if (this.state.upSuccer == true) {
			errMsg = '';
		} else if (this.state.upSuccer == false) {
			errMsg = errorMessage && errorMessage.message;
		}

        let picUp = this.props.picUp ? this.props.picUp : false;
		let domain = '';
		return (
			<FileUploader
				ref="fileUploader"
				talentId={BSGlobal['loginUserInfo']['TenantID']}
				domain={domain}
				// multiple={this.props.cmp_data.multiple}
				multiple={false}
				filenumber={this.state.filenumber}
				uploadCount={this.props.cmp_data.uploadCount || 1}
				showMode={this.props.cmp_data.cmp_state == 'show'}
				action={uploadURL}
				accept={this.getAcceptProps()}
				required={required}
				fileListMess={this.state.fileList}
				allowUpload={this.allowUpload()}
				allowDelete={this.allowDelete()}
				allowDownload={true}
				downloadURL={downloadUrl}
				deleteUrl=''
				onDelete={this.handleDelete}
				onSuccess={this.handleSuccess}
				onError={this.handleError}
				beforeUpload={this.handleBeforeUpload}
				onChange={this.handleChange}
				getDeleteParam={this.getDeleteParam}
				isReadOnly={this.props.isReadOnly}
				label={this.props.label}
                filename="path"
                desc={desc}
				errorMsg={errMsg}
				tipErrorMessage={this.tipErrorMessage}
				onFocus={this.props.onFocus}
				picUp={picUp}
				translation={translation}
				promptmessage={this.props.cmp_data.promptmessage}
                styleTitle={styleTitle}
			/>
		);
	}
}

FileUpload.defaultProps = {
	cmp_data: {
		clientUrl: '',
		downloadUrl: '',
		fileName: '',
		uploadUrl: '',
		deleteUrl: '',
		value: '',
		text: '',
		uploadDate: '',
		size: '',
		cmp_status: ''
	}
};

FileUpload.contextTypes = {
	actions: React.PropTypes.object,
	form_context: React.PropTypes.object.isRequired
};

export default FileUpload;



// WEBPACK FOOTER //
// ./src/components/Field_Components/FileUpload/FileUpload.js